import axios from 'axios';
import { CrawledPopupStoreSummary } from './crawls.type';

interface CrawledPopupStoreSummaries {
  popupStores: CrawledPopupStoreSummary[];
}

export const CrawlOpenPopupStores = async (): Promise<CrawledPopupStoreSummary[]> => {
  try {
    const { data } = await axios.get<CrawledPopupStoreSummaries>('https://crawl.prezemadmin.com/popup-stores');

    return data.popupStores ?? [];
  } catch {
    return [];
  }
}
